var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',[_c('router-view')],1),_vm._v(" "),_c('footer',[_c('p',{staticClass:"copy"},[_vm._v(_vm._s(_vm.$t('footer.copyright')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }